import { Confirm } from "./types";

export const ConfirmActions = {
    Open: (options = {}) => {
        return {
            type: Confirm.OPEN,
            options,
        };
    },
    Close: () => {
        return {
            type: Confirm.CLOSE,
        };
    },
};
